import { Button, Card, Col, Input, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { BaseApi } from '../base.api'
import { useLocation } from 'react-router-dom'

const UpdateSource = () => {
    const location = useLocation()
    const {id} = location.state || {}
    const [tag, setTag] = useState({name:""})
    useEffect(() => {
      const fechData= async()=>{
        if (id) { 
        const response = await new BaseApi().fetchData(`common-service/v1/tags/source-tag/${id}`)
        setTag(response?.data.data)
      }}
      fechData()
    }, [id])
    
    const handleSubmit= async ()=>{
        const response = await new BaseApi().putData(`common-service/v1/tags/source-tag/${id}`,tag)
        console.log(response);
        
        if (response) {
            console.log("succesfully");
            window.location.href="/main/sources"
          } else {
            console.log("Failed");
            window.location.href="/main/sources"
  
        }
    }
    const handleChange=(e:any)=>{
      setTag({...tag,name:e.target.value})
      console.log(tag)
      
    }
   
  return (
    <div>
      <Button ><a href='/main/sources'>Main page</a></Button>
         <Card
        style={{ width: 500, marginLeft: 400, marginBottom: 80, marginTop: 80 }}
        title="Update Tag"
      >
        <form >
          <Row gutter={16}>
            <Col span={24}>
              <div>
                <label>Name </label>
                <Input
                  type="text"
                  value={tag.name}
                  onChange={(e)=>handleChange(e)}
                  placeholder="Enter... "
                  required
                />
              </div>
            </Col>
          </Row>
          <Row justify="center" style={{ marginTop: 16 }}>
            <Col>
              <Button type="primary" onClick={handleSubmit}>
                Save
              </Button>
            </Col>
          </Row>
        </form>
      </Card>
    </div>
  )
}

export default UpdateSource